// extracted by css-extract-rspack-plugin
export default {"CtaBanner":"CtaBanner-module__CtaBanner__xU9TN","CtaBanner__container":"CtaBanner-module__CtaBanner__container__axnLc"};